import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { ReservationSummaryDocumentsComponent } from '../reservation-summary/reservation-summary-documents/reservation-summary-documents.component';
import { Reservation } from '../reservation.model';
import { DatePipe } from '@angular/common';
import { filter } from 'rxjs';
import { PricePipe } from '@/common/pipes/price.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-reservation-documents',
	templateUrl: './reservation-documents.component.html',
	styleUrls: ['./reservation-documents.component.scss'],
	providers: [DatePipe, PricePipe],
})
export class ReservationDocumentsComponent extends ReservationSummaryDocumentsComponent implements OnInit {
	displayedColumns: string[] = ['icon', 'name', 'date', 'author'];

	private readonly destroyRef = inject(DestroyRef);

	ngOnInit() {
		this._service.reservation$
			.pipe(
				filter((value) => !!value),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((value: Reservation) => {
				this.reservation = value;
				console.log(this.reservation);
			});

		this.store
			.getters()
			.document()
			.pipe(
				filter((v) => !!v),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((v) => {
				this.documents = v.filter((value) => value.name !== 'reservation_cash_confirmation');
			});
	}
}
